import React, { Component } from 'react'
import './index.less'

interface Props {
    title: string
    className: string
}
export default class CellTitle extends Component<Props> {

    render() {
        return <div className={this.props.className}>
            {this.props.title}
        </div>

    }
}